import { render, staticRenderFns } from "./DX.vue?vue&type=template&id=5b17be7e"
import script from "./DX.vue?vue&type=script&lang=ts"
export * from "./DX.vue?vue&type=script&lang=ts"
import style0 from "./DX.vue?vue&type=style&index=0&id=5b17be7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports